const PurchaseCategorySelector = ({ selectedCategory, onSelectCategory, isRTL = false }) => {
    // Define all purchase categories with their points rates
    const purchaseCategories = [
      { id: 'cardsDevicesOffers', name: 'بطاقات - اجهزة - عروض', pointsRate: 0.01, icon: '💳' },
      { id: 'gamesBrands', name: 'العاب - براندات 250-500', pointsRate: 0.02, icon: '🎮' },
      { id: 'accessoriesPartsChairs', name: 'اكسسوارات - قطع كمبيوتر - طاولات كراسي', pointsRate: 0.03, icon: '🎧' },
      { id: 'accessories550to1000', name: 'اكسسوارات 550 - 1000', pointsRate: 0.04, icon: '🎯' },
      { id: 'accessories100to500', name: 'اكسسوارات 100-500', pointsRate: 0.05, icon: '🛒' },
      { id: 'vipCustomer', name: 'زبون مميز', pointsRate: 0.06, icon: '⭐' },
    ];
  
    return (
      <div className="category-selector-container">
        <h4 className="category-title">فئة المشتريات</h4>
        <div className="categories-grid">
          {purchaseCategories.map((category) => (
            <div
              key={category.id}
              className={`category-card ${selectedCategory === category.id ? 'selected' : ''}`}
              onClick={() => onSelectCategory(category)}
            >
              <div className="category-icon">{category.icon}</div>
              <div className="category-info">
                <div className="category-name">{category.name}</div>
                <div className="category-rate">{(category.pointsRate * 100).toFixed(1)}%</div>
              </div>
            </div>
          ))}
        </div>
  
        <style jsx>{`
          .category-selector-container {
            margin-bottom: 16px;
          }
          
          .category-title {
            font-size: 16px;
            margin-bottom: 8px;
            font-weight: 600;
            color: #333;
            text-align: ${isRTL ? 'right' : 'left'};
          }
          
          .categories-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            padding: 4px;
            direction: ${isRTL ? 'rtl' : 'ltr'};
          }
          
          .category-card {
            display: flex;
            align-items: center;
            padding: 8px;
            border: 1px solid #ddd;
            border-radius: 8px;
            background-color: #f9f9f9;
            cursor: pointer;
            transition: all 0.2s ease;
          }
          
          .category-card:hover {
            background-color: #f0f0f0;
            transform: translateY(-2px);
          }
          
          .category-card.selected {
            border-color: #4a90e2;
            background-color: #e6f2ff;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
          }
          
          .category-icon {
            font-size: 20px;
            margin-right: 8px;
            margin-left: ${isRTL ? '8px' : '0'};
          }
          
          .category-info {
            flex: 1;
          }
          
          .category-name {
            font-size: 14px;
            font-weight: 500;
          }
          
          .category-rate {
            font-size: 12px;
            color: #666;
          }
          
          @media (max-width: 768px) {
            .categories-grid {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
      </div>
    );
  };
  
  export default PurchaseCategorySelector;